$('.table-of-contents .button').on("click", function(e) {
    const anchorId =  $(this).attr('href');
    const $customerSwitcher = $('.customer-switcher');
    const headerHeight = $(".header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

    if(anchorId && anchorId.startsWith('#') && anchorId !== '#') {
        e.preventDefault();
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(anchorId).offset().top - headerHeight
            }, 200);
        }, 400);
    }
});